import React from 'react';
import { isKingRole, hasActiveVoters } from './utils/gameUtils';

// Player role display + eliminated/king-only status
const PlayerBanner = ({ game, playerData, playerTeam, isEliminated }) => {
  if (!playerData?.role) return null;

  const isKing = isKingRole(playerData.role);
  const isKingOnly = isKing && !hasActiveVoters(game, playerTeam);

  return (
    <div className={`player-roles-banner ${isEliminated ? 'eliminated-banner' : ''} ${isKingOnly ? 'king-only-banner' : ''}`}>
      <h3>Your Piece: {playerData.role}</h3>
      {isEliminated ? (
        <>
          <p className="eliminated-status">YOU HAVE BEEN ELIMINATED</p>
          <p className="eliminated-note">Your piece was captured. You can still watch and chat, but cannot suggest moves or vote.</p>
        </>
      ) : isKingOnly ? (
        <p className="collaborative-note king-direct-mode">You are the only active player! Drag pieces to move directly without voting.</p>
      ) : (
        <p className="collaborative-note">Drag pieces to suggest moves! {isKing ? 'As King, you create polls from suggestions.' : 'The King creates polls from suggestions.'}</p>
      )}
    </div>
  );
};

export default PlayerBanner;
